export default "__VITE_ASSET__DG0mx0$E__"